module.exports = __webpack_public_path__ + "028920f8612e5b89c31edcb3e9c578f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/nuocmam.jpg
// module id = ./assets/images/favorite/nuocmam.jpg
// module chunks = 0